module.exports = __webpack_public_path__ + "static/close-x-icon-a61f46420d5b5e376e44ab341d11e34a.jpg";